/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowrsvphint2Inputs */

const en_rowrsvphint2 = /** @type {(inputs: Rowrsvphint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests can also say they are not coming.`)
};

const de_rowrsvphint2 = /** @type {(inputs: Rowrsvphint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste können auch „Bin nicht dabei“ sagen.`)
};

/**
* | output |
* | --- |
* | "Guests can also say they are not coming." |
*
* @param {Rowrsvphint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowrsvphint2 = /** @type {((inputs?: Rowrsvphint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowrsvphint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowrsvphint2(inputs)
	return de_rowrsvphint2(inputs)
});
export { rowrsvphint2 as "rowRsvpHint" }